// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"218":"component---src-pages-404-tsx","351":"commons","691":"component---src-pages-index-tsx"}[chunkId] || chunkId) + "-" + {"218":"24f6d9a2cd88f781330e","351":"63905aafe5af49014348","691":"c21c863fd068f9e2ffe8","731":"4786141a1da08a09be6c","843":"15fadd4364063cb3aaf5"}[chunkId] + ".js";
};